import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { AppointmentService } from 'services';
import { PetService } from 'services/pet.service.ts';
import { TreatmentService } from 'services/treatment.service';
import { ITreatmentOnGoing } from 'types';
import { IPetHistory } from 'types/PetHistory';

import { AlertColor } from '@mui/material';
import { Snackbar } from 'components/Snackbar';
import { useHistory } from 'react-router-dom';
import { Backdrop } from 'components/Backdrop';
import { FormProvider, useForm } from 'react-hook-form';

interface ISnackbar {
  message: string | null;
  variant?: AlertColor | undefined;
}

export interface ITreatmentContext {
  petHistory: IPetHistory[];
  treatmentOnGoing: ITreatmentOnGoing;
  getTreatmentInQueue: () => Promise<void>;
  getTreatmentOnGoing: () => Promise<void>;
  getPetHistory: (petId: string) => Promise<void>;
  loading: boolean;
  finishTreatmentOnGoing: () => Promise<void>;
  saveAnnotations: () => Promise<void>;
}

export const TreatmentContext = createContext<ITreatmentContext>(
  {} as ITreatmentContext
);

type Props = {
  children: ReactNode;
};

export const TreatmentProvider = ({ children }: Props) => {
  const [petHistory, setPetHistory] = useState<IPetHistory[]>([]);
  const [treatmentOnGoing, setTreatmentOnGoing] = useState<ITreatmentOnGoing>(
    {} as ITreatmentOnGoing
  );
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState<ISnackbar>({
    message: '',
    variant: 'info',
  });
  const { replace } = useHistory();

  const form = useForm({ defaultValues: { annotations: '' } });

  const getPetHistory = async (petId: string) => {
    /* const petHistory = await PetService.getPetHistory({ petId });
    setPetHistory(petHistory || []); */
  };

  const getTreatmentInQueue = async () => {
    try {
      // const { pet } = await AppointmentService.getAppointmentInfo();

      // setPet(pet);
    } catch (err) {
      console.error(err);
    }
  };

  const getTreatmentOnGoing = useCallback(async () => {
    try {
      const data = await TreatmentService.getCurrentTreatmentOnGoing();

      setTreatmentOnGoing(data);

      // getPetHistory(data.pet.id);
    } catch (err) {
      setSnackbar({
        message: 'Não foi possível carregar o atendimento',
        variant: 'error',
      });
    }
  }, []);

  const finishTreatmentOnGoing = async () => {
    if (!treatmentOnGoing) {
      return;
    }

    try {
      setLoading(true);

      const { annotations } = form.getValues();

      await AppointmentService.finishTreatmentOnGoing({
        annotations,
        roomId: treatmentOnGoing.roomId,
        treatmentId: treatmentOnGoing._id,
      });

      setSnackbar({
        message: 'Atendimento finalizado com sucesso',
        variant: 'success',
      });

      replace('/vet/dashboard/');
    } catch (error: any) {
      setSnackbar({
        message: 'Não foi possível encerrar o atendimento',
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const saveAnnotations = async () => {
    try {
      setLoading(true);

      const { annotations } = form.getValues();

      await AppointmentService.updateTreatmentAnotation({
        treatmentId: treatmentOnGoing?._id,
        annotations,
      });

      setSnackbar({
        variant: 'success',
        message: 'Anotações salvas com sucesso',
      });
    } catch (err) {
      setSnackbar({
        variant: 'error',
        message: 'Não foi possível salvar as anotações',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTreatmentOnGoing();
  }, [getTreatmentOnGoing]);

  return (
    <TreatmentContext.Provider
      value={{
        petHistory,
        getPetHistory,
        getTreatmentInQueue,
        getTreatmentOnGoing,
        treatmentOnGoing,
        loading,
        finishTreatmentOnGoing,
        saveAnnotations,
      }}
    >
      <FormProvider {...form}>{children}</FormProvider>

      <Snackbar
        text={snackbar.message}
        snackbarOpen={Boolean(snackbar.message)}
        setSnackbarOpen={() => {
          setSnackbar({
            message: '',
          });
        }}
        severityType={snackbar.variant}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />

      <Backdrop open={loading} />
    </TreatmentContext.Provider>
  );
};

